export default __webpack_public_path__ + "static/media/step_018.42ca02e8.jpeg";